import React, { useState, useContext } from "react";
import { StyleSheet, Image } from "react-native";
import * as Yup from "yup";
//import AsyncStorage from "@react-native-async-storage/async-storage";
//import useAuth from "../auth/useAuth";

import Screen from "../components/Screen";
import {
  ErrorMessage,
  Form,
  FormField,
  SubmitButton,
} from "../components/forms";
import storage from "../auth/storage";
import connectionConfig from "../config/settings";
//import settingStorage from "../config/settingStorage";
//import AppNavigator from "../navigation/AppNavigator";
// import configurationPost from "../config/configurationPost";
// import routes from "../navigation/routes";
import AuthContext from "../auth/context";

const validationSchema = Yup.object().shape({
  email: Yup.string().required().email().label("Email"),
  password: Yup.string().required().min(4).label("Password"),
});

function LoginScreen(props) {
  //const auth = useAuth(); 
  //const [user, setUser] = useState("Register") 
  const { user, setUser } = useContext(AuthContext);
  const [loginFailed, setLoginFailed] = useState(false);
  var access_fixo = []
  var error_message = '';

  const handleSubmitSql = async ({ email, password }) => {
    debugger
    setLoginFailed(false);
    var post_values = {
      email : email,
      password : password 
    }
    var configurationPost = {
      method: 'post',
      headers: {
        'Accept': 'application/json, text/plain, *.*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(post_values)
    }
   // configurationPost.body = JSON.stringify(post_values)
  // alert('login submit')
    console.log('log')
    //solicita el servicio para login fixo remoto
    await fetch(connectionConfig.apiUrl+'/loginFixo/select', configurationPost)
      .then(response => response.json())
      .then(response => {
        debugger   //alert('login submit')
              //alert('login submit response 555555', response.data.length())

        console.log('login regresa', response)
        access_fixo = response.data
      })
      .catch(err =>{
        console.log('login fixo failed :( review internet service', err )
        setLoginFailed(true);       
      })
      if(loginFailed === false){
        if(access_fixo.length === 0 || access_fixo === 'error en query'){
          error_message = 'Invalid email and/or password.'
          console.log(error_message)
        }else{
          var settingStorage = {
            json: {
                country: '',
                userId: '',
                userName: '',
                email: '',
                userPhoto: '',
                userPassword: '',
                createDate: '',
                countryId: '',
                country: '',
                alias: ''
            },
            KEY: 'fixo.charly'
          }
                     alert('login fixo success ;) ', access_fixo)

           console.log('login fixo success ;) ', access_fixo)
          
          settingStorage.json.country = access_fixo[0].country
          settingStorage.json.userId = access_fixo[0].userId
          settingStorage.json.userName = access_fixo[0].userName
          settingStorage.json.userPhoto = access_fixo[0].userPhoto
         // settingStorage.json.roles = access_fixo[0].roles
          settingStorage.json.email = access_fixo[0].email
          settingStorage.json.createDate = access_fixo[0].createDate       
  
        //  // await AsyncStorage.setItem(settingStorage.KEY, JSON.stringify(settingStorage.json)) 
      var userInformation = JSON.stringify(settingStorage.json)  
        //    //debugger
 
          storage.storeToken(userInformation);
          //useAuth.logIn(userInformation);
          //props.navigation.navigate(routes.ACCOUNT)
           setUser(userInformation)
        }
      }
  }

 
  return (
    <>
    {/* {user === "Register" ? */}
    <Screen style={styles.container}>
      <Image style={styles.logo} source={require("../assets/fixoNegro.png")} />

      <Form
        initialValues={{ email: "a@gmail.com", password: "12345" }}
        onSubmit={handleSubmitSql}
        validationSchema={validationSchema}
      >
        <ErrorMessage
          error="Invalid email and/or password."
          visible={loginFailed}
        />
        <FormField
          autoCapitalize="none"
          autoCorrect={false}
          icon="email"
          keyboardType="email-address"
          name="email"
          placeholder="Email"
          textContentType="emailAddress"
        />
        <FormField
          autoCapitalize="none"
          autoCorrect={false}
          icon="lock"
          name="password"
          placeholder="Password"
          secureTextEntry
          textContentType="password"
        />
        <SubmitButton title="Login" />
      </Form>
    </Screen>
    {/* :
    <AppNavigator />  */}
  {/* } */}
  </>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 10,
  },
  logo: {
    width: 80,
    height: 80,
    borderRadius:50,
    alignSelf: "center",
    marginTop: 50,
    marginBottom: 20,
  },
});

export default LoginScreen;
